module.exports = __webpack_public_path__ + "img/title_prev.661875c3.png";